export const COLORS = {
  background: '#0a0a0f',
  panel: '#0d0d15',
  primary: '#00e5ff',
  secondary: '#ff3366',
  success: '#00ff88',
  warning: '#ffaa00',
  text: '#e0e0e0',
  textSecondary: '#8888aa',
  grid: '#1a1a2e',
  border: '#333355',
  path: '#333355',
  initialCapital: '#ffaa00',
} as const

export const SEMI_TRANSPARENT = {
  danger: 'rgba(255, 51, 102, 0.3)',
  warning: 'rgba(255, 170, 0, 0.3)',
  success: 'rgba(0, 255, 136, 0.3)',
  excellent: 'rgba(0, 229, 255, 0.3)',
  band5_95: 'rgba(0, 229, 255, 0.08)',
  band10_90: 'rgba(0, 229, 255, 0.15)',
  path: 'rgba(51, 51, 85, 0.15)',
  initialCapital: 'rgba(255, 170, 0, 0.5)',
} as const

export const FONT_FAMILY = 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'

export const SIZES = {
  gap: '16px',
  padding: '16px',
  borderRadius: '0px',
  title: '14px',
  subtitle: '10px',
  data: '11px',
  score: '42px',
  unit: '14px',
} as const
